@switch (kind) {
  @case ('stitch') {
    <!-- A needle stitching a red thread across a scrap of paper -->
    <svg class="tss" viewBox="0 0 140 90" aria-hidden="true">
      <rect class="tss-paper" x="10" y="40" width="112" height="34" rx="4" transform="rotate(-4 66 57)"/>
      <path class="tss-stitch" style="--i: 0" d="M18,60 L26,58.5"/>
      <path class="tss-stitch" style="--i: 1" d="M32,57.5 L40,56.5"/>
      <path class="tss-stitch" style="--i: 2" d="M46,56 L54,55.5"/>
      <path class="tss-stitch" style="--i: 3" d="M60,55 L68,54.5"/>
      <path class="tss-stitch" style="--i: 4" d="M74,54 L82,53"/>
      <path class="tss-stitch" style="--i: 5" d="M88,52 L95,51"/>
      <g class="tss-needle">
        <path class="tss-thread" d="M95,51 C104,40 108,30 119,24 C126,20 134,26 130,36"/>
        <path class="tss-needle__body" d="M100,54 L122,19"/>
        <ellipse class="tss-needle__eye" cx="119.5" cy="23" rx="1.1" ry="2.4" transform="rotate(32 119.5 23)"/>
      </g>
    </svg>
  }
  @case ('feather') {
    <!-- A quill feather drifting down towards a one-cent coin -->
    <svg class="tss" viewBox="0 0 140 100" aria-hidden="true">
      <g class="tss-coin">
        <ellipse class="tss-coin__edge" cx="30" cy="88" rx="19" ry="5.5"/>
        <ellipse class="tss-coin__face" cx="30" cy="84" rx="19" ry="5.5"/>
        <text class="tss-coin__label" x="30" y="86.6" text-anchor="middle">1¢</text>
      </g>
      <g transform="translate(14 -12)">
      <g class="tss-feather">
        <path class="tss-feather__vane" d="M64,78 C66,58 78,34 104,14 C108,30 100,52 84,66 C78,71 70,75 64,78 Z"/>
        <path class="tss-feather__notch" d="M88,38 L95,34 M80,52 L88,49"/>
        <path class="tss-feather__shaft" d="M58,86 C68,64 82,38 104,14"/>
      </g>
      </g>
    </svg>
  }
  @case ('sheep') {
    <app-winged-sheep></app-winged-sheep>
  }
}
